/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Voice_Ph_Ten_Khach_DescInputs */

const vi_station_voice_ph_ten_khach_desc = /** @type {(inputs: Station_Voice_Ph_Ten_Khach_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên khách (rỗng đọc là khách lẻ)`)
};

/**

* @param {Station_Voice_Ph_Ten_Khach_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_voice_ph_ten_khach_desc = /** @type {((inputs?: Station_Voice_Ph_Ten_Khach_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Voice_Ph_Ten_Khach_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_voice_ph_ten_khach_desc(inputs)
});